import { render, staticRenderFns } from "./goll.vue?vue&type=template&id=c7603494"
import script from "./goll.vue?vue&type=script&lang=js"
export * from "./goll.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports